export default __webpack_public_path__ + "e5d524532c88c80b3dc24402554e4cb7.png";